exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loader {\n  text-align: center;\n}\n\n.loader-text {\n  color: #FFFFFF;\n}", ""]);

